import type { ITableLikeTreeItem } from 'components/TableLikeTree/context';

export type TFilters =
    | {
          codeWBS: string;
      }
    | undefined;

export const getFilteredTree = (items: ITableLikeTreeItem[] = [], filters: TFilters) => {
    if (!filters?.codeWBS) {
        return items;
    }

    const filterNode = (node: ITableLikeTreeItem): ITableLikeTreeItem | null => {
        const filteredChildren = node?.children?.map(filterNode).filter((child) => Boolean(child));

        const matchesSelf = node.codeWBS?.includes(filters?.codeWBS) ?? false;

        if (matchesSelf || filteredChildren?.length) {
            return {
                ...node,
                children: filteredChildren as ITableLikeTreeItem[],
            };
        }

        return null;
    };

    return items.map(filterNode).filter((node) => Boolean(node)) as ITableLikeTreeItem[];
};
